module.exports = __webpack_public_path__ + "static/media/yt-sledding.db7ecb39.mov";